import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export function usePreOrderImage() {
  const { locale } = useI18n()

  const preOrderImage = computed(() => {
    if (locale.value === 'fr') {
      return '/images/product/Label-Pre-Order-FR.svg'
    }
    return '/images/product/Label-Pre-Order-DE.svg'
  })

  return {
    preOrderImage,
  }
}
